export default "__VITE_ASSET__bSjd9TXL__"